<div [formGroup]="formularzUszkodzenia">
  <label class="c-label c-label--checkbox c-checkbox c-label--inline">
    <input formControlName="foliaReklamowa" type="checkbox" class="c-checkbox u-hidden">
    <span class="c-checkbox__replacement"></span>
    <span class="c-label__title text">{{etykieta}}</span>
  </label>
</div>
